import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/vHome.vue'
import Customers from '../views/vCustomers.vue'
import DocumentsWithParts from '../views/vDocumentsWithParts.vue'
import PartsWithDocuments from '../views/vPartsWithDocuments.vue'
import LandingFlex from '../views/vLandingHolder'
import Insights from '../views/vInsights.vue'
import dd from '../components/cDocumentDashboard.vue'
import UserList from '../components/cUserList.vue'
import ClientList from '../components/cClientList.vue'
import governance from '../components/cGovernance.vue'
import TemplateBuilder from '../views/vTemplateBuilder'
import vAgentChat from '../views/vAgentChat.vue'
import ReviewGroups from '../views/vReviewGroups'
import BrandedContent from '../components/cBrandedContent'
import LevellingEvaluation from "@/components/levellingEvaluation/EvaluationHolder.vue";
import ClassificationList from '../components/cClassificationList.vue'
import AdminHolder from '../components/admin/cAdminHolder.vue'
import AdminAtlasHolder from '../components/admin/cAdminAtlasHolder.vue'
import ReportHolder from '../components/cReportsHolder.vue'
import UploadContent from '../components/cUploadContent.vue'
import UploadContentNew from '../components/cUploadContentNew.vue'
import ReportDataUpload from '../components/dataUpload/cReportDataUpload.vue'
import DocumentTraining from '../components/cDocumentTraining.vue'
import SimpleDocParts from '../components/cSimpleDocParts.vue'
import AdminDocClassifierRules from '../components/cAdminDocClassifierRules.vue'
import WorkflowEngine from '../components/cWorkflowEngine.vue'
import RouteAdmin from '../views/vRouteAdmin.vue'
import LandingConfig from '../views/vLandingConfig.vue'
import Tasks from '../components/cTasks.vue'
import EventsGateway from '../components/cEventsGatewayLog.vue'
import HierarchyView from '../components/cHierarchyView.vue'
import HierarchyConfig from '../components/hierarchy/cHierarchyConfig.vue'
import AdminHierarchy from '../components/hierarchy/cAdminHierarchy.vue'
import AdminTags from '../components/admin/cAdminTagsAlt.vue'
// import QuestionnaireReport from '../components/cQuestionnaireSummary'
import DocViewAdmin from '../components/document/view/View_Admin.vue'
import similarityAnalysis from '../components/jobArchitecture/similarityAnalysis.vue'
import SkillManager from '../components/skills/cSkillManager.vue'
import SkillFrameworkAdmin from '../components/skills/cSkillAdmin.vue'
import BaseSkillsAdmin from '../components/skills/cBaseSkillsAdmin.vue'
import AtlasConnectorAdmin from '../components/admin/AtlasConnectorAdmin.vue'
import TagCompare from "@/components/jobArchitecture/TagCompare";
//import DocViewAdmin from '../components/document/view/Document_View_Admin.vue'
import HierarchyViewAlt from '../components/jobArchitecture/HierarchyViewAlt.vue'
import ReportContainer from '../components/jobArchitecture/ReportContainer.vue'
import NotificationList from '../components/notifications/NotificationList.vue'
import LevellingFrameworkPage from '../components/levelling/LevellingFrameworkPage.vue'
import PayEquityPage from '../components/levelling/PayEquityPage.vue'
import JobMappingPage from '../components/levelling/JobMappingPage.vue'
import ExcelSessionRunner from '../components/common/ExcelSessionRunner.vue'
import LevellingView from '../views/vLevelling.vue'
import cLevellingControlCentre from '../components/levelling/cLevellingControlCentre.vue'

Vue.use(VueRouter)

const menuSections = [
	{ name: 'Reporting', icon: 'assessment'},
	{ name: 'Admin', icon: 'admin_panel_settings' }
];

const routes = [
	{
		path: '/',
		name: 'default'
	}, {
		path: '/u/:user/customers',
		name: 'customers',
		component: Customers,
		meta: { text: 'Customer List', icon: 'manage_accounts', newUi: true, oldUi: false, internal: true, v3: { rail: 11, icon: 'group' } }
	}, {
		path: '/u/:user/home',
		name: 'home',
		component: Home,
		meta: { text: 'Home', icon: 'home', newUi: true, oldUi: true }
	}, {
		path: '/u/:user/myjobs',
		name: 'myjobs',
		component: DocumentsWithParts,
		meta: { text: 'My Jobs', icon: 'assignment', newUi: true, oldUi: false, v3: { parent: 'alljobs', order: 2 } }
	}, {
		path: '/u/:user/alljobs',
		name: 'alljobs',
		component: DocumentsWithParts,
		meta: { text: 'All Jobs', icon: 'dvr', newUi: true, oldUi: false, v3: { rail: 3, icon: 'description', parent: 'alljobs', order: 1 } }
	}, {
		path: '/u/:user/levelling',
		name: 'levelling',
		component: cLevellingControlCentre,
		meta: { text: 'Levelling', icon: 'checklist', newUi: true, oldUi: false, v3: { rail: 5, parent: 'levelling', order: 1, tocText: 'Levelling Control Centre' } }
	}, {
		// Job Mapping (renamed Job Architecture) — third ToC entry.
		path: '/u/:user/levellingjobmapping',
		name: 'levellingjobmapping',
		component: JobMappingPage,
		meta: { text: 'Job Mapping', icon: 'sensors', newUi: true, oldUi: false, allowAll: true, v3: { parent: 'levelling', order: 3, icon: 'account_tree' } }
	}, {
		path: '/u/:user/docswithparts',
		name: 'docswithparts',
		component: DocumentsWithParts,
		meta: { text: 'Database', icon: 'dvr', newUi: false, oldUi: true }
	}, {
		path: '/u/:user/partswithdocs',
		name: 'partswithdocs',
		component: PartsWithDocuments,
		meta: { text: 'QA', icon: 'app_registration', newUi: false, oldUi: true }
	}, {
		path: '/u/:user/contentmanager',
		name: 'contentmanager',
		component: PartsWithDocuments,
		meta: { text: 'Content Manager', icon: 'app_registration', newUi: true, oldUi: false, v3: { parent: 'alljobs', order: 3 } }
	}, {
		path: '/u/:user/evaluate/:docReference',
		name: 'evaluate',
		component: LevellingEvaluation,
		props: true,
		meta: { text: 'Evaluate New', allowAll: true, icon: 'try', newUi: false, oldUi: false, hideHeaderCreate: true, hideHeaderAndMenu: true }
	}, {
		path: '/u/:user/brandedcontent',
		name: 'brandedcontent',
		component: BrandedContent,
		meta: { text: 'Brand Content', icon: 'edit_note', newUi: false, oldUi: true }
	}, {
		path: '/u/:user/templatebuilder',
		name: 'templatebuilder',
		component: TemplateBuilder,
		meta: { text: 'Template Builder', icon: 'web', section: 'Admin', newUi: true, oldUi: true, reserved: true, v3: { parent: 'admin' } },
	}, { 
		path: '/u/:user/agent', name: 'agentChat', component: vAgentChat, 
		meta: { text: 'Atlas', icon: 'mdi-compass-outline', newUi: true, oldUi: true, module_setting: 'atlas_available', v3: { rail: 2, icon: 'explore' } }},
	{
		path: '/u/:user/userlist',
		name: 'userlist',
		component: UserList,
		meta: { text: 'Users', icon: 'manage_accounts', section: 'Admin', newUi: true, oldUi: true, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/reviewgroups',
		name: 'reviewgroups',
		component: ReviewGroups,
		meta: { text: 'Review Groups', icon: 'people', section: 'Admin', newUi: true, oldUi: true, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/clientlist',
		name: 'clientlist',
		component: ClientList,
		meta: { text: 'Customer Admin', icon: 'business', section: 'Admin', newUi: true, oldUi: true, reserved: true, internal: true, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/governance',
		name: 'governance',
		component: governance,
		meta: { text: 'Governance', icon: 'account_balance', section: 'Reporting', newUi: false, oldUi: true }
	}, {
		path: '/u/:user/classification',
		name: 'classification',
		component: ClassificationList,
		meta: { text: 'Classifiers', icon: 'layers', section: 'Reporting', newUi: true, oldUi: true, v3: { parent: 'reporting', order: 3 } }
	}, {
		path: '/u/:user/simpleSearch',
		name: 'simpleSearch',
		component: SimpleDocParts,
		meta: { text: 'Simple', icon: 'pageview outlined', newUi: true, oldUi: true }
	}, {
		path: '/u/:user/uploadContent',
		name: 'uploadContent',
		component: UploadContent,
		meta: { text: 'Upload Content', icon: 'upload', section: 'Admin', newUi: true, oldUi: true, v3: { parent: 'admin' } }
	},{
		path: '/u/:user/dataUpload',
		name: 'dataUpload',
		component: UploadContentNew,
		meta: { text: 'Data Upload', icon: 'upload', section: 'Admin', newUi: true, oldUi: true, v3: { parent: 'admin' } }
	},{
		path: '/u/:user/docTraining',
		name: 'docTraining',
		component: DocumentTraining, 
		meta: { text: 'Document Training', newUi: false, oldUi: false }
	},{
		path: '/u/:user/admin',
		name: 'admin',
		component: AdminHolder,
		meta: { text: 'Admin', icon: 'settings outlined', section: 'Admin', newUi: true, oldUi: true, reserved: true, v3: { parent: 'admin', order: 1 } }
	}, {
		path: '/u/:user/atlasadmin',
		name: 'atlasadmin',
		component: AdminAtlasHolder,
		meta: { text: 'Atlas Admin', icon: 'explore', section: 'Admin', newUi: true, oldUi: true, reserved: true, module_setting: 'atlas_available', v3: { parent: 'admin', order: 2 } }
	}, {
		path: '/u/:user/classifierRules',
		name: 'classifierRules',
		component: AdminDocClassifierRules,
		meta: { text: 'Classifier Rules', icon: 'checklist_rtl', section: 'Admin', newUi: true, oldUi: true, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/usageReports/:reportName?',
		name: 'usageReports',
		component: ReportHolder,
		meta: { text: 'Usage Reports', icon: 'summarize outlined', section: 'Reporting', newUi: true, oldUi: true, v3: { parent: 'reporting', order: 2, tocText: 'Usage Dashboard' } }
	}, {
		path: '/u/:user/workflow',
		name: 'workflow',
		component: WorkflowEngine,
		meta: { text: 'Workflow Engine', icon: 'summarize outlined', section: 'Admin', newUi: true, oldUi: false, reserved: true, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/routeadmin',
		name: 'routeadmin',
		component: RouteAdmin,
		meta: { text: 'Page Permissions', icon: 'route', section: 'Admin', newUi: true, oldUi: false, reserved: true, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/landingconfig',
		name: 'landingconfig',
		component: LandingConfig,
		meta: { text: 'Landing Config', icon: 'layers', section: 'Admin', newUi: true, oldUi: false, reserved: true, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/tasks',
		name: 'tasks',
		component: Tasks,
		meta: { text: 'Tasks', icon: 'summarize outlined', newUi: true, oldUi: false, v3: { parent: 'home', order: 1, icon: 'task_alt' } }
	}, {
		path: '/u/:user/eventsGateway',
		name: 'eventsGateway',
		component: EventsGateway,
		meta: { text: 'Events Gateway Log', icon: 'sensors', reserved: true }
	}, {
		path: '/u/:user/hierarchyview',
		name: 'hierarchyview',
		component: HierarchyView,
		meta: { text: 'Job Architecture (Old)', icon: 'sensors', newUi: true, oldUi: false, v3: { rail: 6, icon: 'schema' } }
	}, {
		path: '/u/:user/architecture',
		name: 'architecture',
		component: HierarchyViewAlt,
		meta: { text: 'Architecture', icon: 'sensors', newUi: true, oldUi: false, v3: { rail: 7, icon: 'account_tree', parent: 'architecture', order: 1, tocText: 'Architecture' } }
	}, {
		path: '/u/:user/architecture2',
		name: 'architecture2',
		component: ReportContainer,
		meta: { text: 'Pay Equity Reporting', icon: 'sensors', newUi: true, oldUi: false, v3: { parent: 'reporting', order: 1, icon: 'balance' } }
	}, {
		path: '/u/:user/jobfamily',
		name: 'jobfamily',
		component: HierarchyView,
		meta: { text: 'Job Family', icon: 'sensors', newUi: true, oldUi: false, v3: { parent: 'architecture', order: 2 } }
	}, {
		path: '/u/:user/similarityAnalysis',
		name: 'similarityAnalysis',
		component: similarityAnalysis,
		meta: { text: 'Similarity Analysis', icon: 'sensors', newUi: true, oldUi: false, v3: { parent: 'architecture', order: 3 } }
	}, {
		path: '/u/:user/hierarchyconfig',
		name: 'hierarchyconfig',
		component: HierarchyConfig,
		meta: { text: 'Hierarchy Config', icon: 'account_tree', section: "Admin", newUi: true, oldUi: false, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/hierarchyadmin',
		name: 'hierarchyadmin',
		component: AdminHierarchy,
		meta: { text: 'Hierarchy Admin', icon: 'account_tree', section: "Admin", newUi: true, oldUi: false, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/managereportdata',
		name: 'managereportdata',
		component: ReportDataUpload,
		meta: { text: 'Reporting Data', icon: 'storage', section: "Admin", newUi: true, oldUi: false, v3: { parent: 'admin' } }
	},  {
		path: '/u/:user/skilladmin',
		name: 'skilladmin',
		component: AdminTags,
		meta: { text: 'Skill Admin', icon: 'local_offer', section: "Admin", newUi: true, oldUi: false, v3: { parent: 'skills', order: 2 } }
	}, {
	// 	path: '/u/:user/questionnairereport',
	// 	name: 'questionnairereport',
	// 	component: QuestionnaireReport,
	// 	meta: { text: 'Questionnaire Summary Report', icon: 'summarize outlined', section: 'Reporting', newUi: true, oldUi: false }
	// }, {
		path: '/u/:user/docViewAdmin',
		name: 'docViewAdmin',
		component: DocViewAdmin,
		meta: { text: 'Document View Setup', icon: 'summarize outlined', newUi: true, oldUi: false, v3: { parent: 'admin' } }
	}, {
		path: '/u/:user/tagcompare',
		name: 'tagcompare',
		component: TagCompare,
		meta: { text: 'Tag Compare', icon: 'local_offer', newUi: true, oldUi: false }
	}//, {
	// 	path: '/about',
	// 	name: 'About',
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
	// 	meta: { text: 'About', icon: 'mdi-information-outline', newUi: true, oldUi: true }
	// }
	,{
		path: '/u/:user/skillmanager',
		name: 'skillmanager',
		component: SkillManager,
		meta: { text: 'Skill Manager', icon: 'checklist', newUi: true, oldUi: false, reserved: true, module: 'RoleSkill', module_setting: 'roleskill_module', v3: { parent: 'skills', order: 1 } }
	}, {
		path: '/u/:user/skillframeworkadmin',
		name: 'skillframeworkadmin',
		component: SkillFrameworkAdmin,
		meta: { text: 'Skill Framework Admin', icon: 'checklist', section: 'Admin', newUi: true, oldUi: false, reserved: true, module: 'RoleSkill', module_setting: 'roleskill_module' }
	}, {
		path: '/u/:user/baseskillsadmin',
		name: 'baseskillsadmin',
		component: BaseSkillsAdmin,
		meta: { text: 'Skills Framework Admin', icon: 'star', section: 'Admin', newUi: true, oldUi: false, reserved: true, internal: true }
	}, {
		path: '/u/:user/atlasconnectoradmin',
		name: 'atlasconnectoradmin',
		component: AtlasConnectorAdmin,
		meta: { text: 'Atlas Connectors', icon: 'hub', section: 'Admin', newUi: true, oldUi: false, reserved: true, internal: true }
	}, {
		path: '/u/:user/notificationlist',
		name: 'notificationlist',
		component: NotificationList,
		meta: { text: 'Notifications', icon: 'notifications_none', newUi: true, oldUi: false, v3: { parent: 'home', order: 2, icon: 'notifications' } }
	}, {
		path: '/u/:user/levellingframework',
		name: 'levellingframework',
		component: LevellingFrameworkPage,
		meta: { text: 'Levelling Framework', icon: 'grid_view', newUi: true, oldUi: false, v3: { parent: 'levelling', order: 2 },
			// Page functions grantable per permission group in Page Permissions (PD-1331). Names are the tab viewTypes.
			// default: granted automatically when a permission group is given this page.
			functions: [
				{ name: 'framework_in_use', text: 'Framework in Use', default: false },
				{ name: 'grade_alignment', text: 'Grade Alignment', default: false },
				{ name: 'level_track_factors', text: 'Factor Descriptors', default: true },
				{ name: 'sub_factors', text: 'Factor Details', default: true },
				{ name: 'administration', text: 'Administration', default: false },
			] }
	}, {		
		path: '/u/:user/excelsession',
		name: 'excelsession',
		component: ExcelSessionRunner,
		meta: { text: 'Excel Session', icon: 'table_chart', section: 'Admin', newUi: true, oldUi: false, v3: { parent: 'admin' } }
	}
]
// ---------------------------------------------------------------------------
// v3 chrome navigation (new UI, ui_layout='V2').
//
// Each route declares its own placement inline via `meta.v3` (so a route is
// defined exactly once — no parallel lookup maps). The OLD menu never reads
// `meta.v3`; it keeps using `text`/`icon`/`newUi`/`oldUi`/`section` untouched.
//
//   meta.v3.rail: <n>     → top-level rail item at position n
//   meta.v3.parent: 'key' → appears in that area's ToC (a group key below, or a
//                           rail route's name). Separate from legacy `section`.
//   meta.v3.section: 'X'  → labelled sub-group header within the parent's ToC
//   meta.v3.order: <n>    → position within the parent (omit → 100 → A-Z)
//   meta.v3.icon: 'name'  → Material Symbols override of meta.icon
//
// The DEFAULT LANDING for a container group is its lowest-order permitted child.
//
// Groups: synthetic rail containers with no page of their own. `key` is what
// children reference via meta.v3.parent.
const v3Groups = [
	// rail 4 is reserved for Employees (exists in rm-portal-beta; no rm-portal route yet)
	{ key: 'skills', text: 'Skill Manager', icon: 'psychology', rail: 8 },
	{ key: 'reporting', text: 'Reporting', icon: 'assessment', rail: 9 },
	{ key: 'admin', text: 'Admin', icon: 'admin_panel_settings', rail: 10 },
];
// ---------------------------------------------------------------------------

const storeDefaultMeta = (route) => route.meta ? route.meta.Default = {...route.meta} : null;
routes.forEach(r => storeDefaultMeta(r));
const router = new VueRouter({
	routes
});

router.menuSections = menuSections;
router.v3Groups = v3Groups;
// Pristine copy of the code-declared groups — group overrides (v3group.* rows)
// rebuild router.v3Groups from this on every apply, so applying is stateless.
router.v3GroupsDefault = v3Groups.map(g => ({ ...g }));

// The v3 rail/drawer renders Material Symbols; DB-configured icons may be
// mdi-based, which that font can't display — fall back per caller.
const v3SafeIcon = (raw, fallback) => {
	const first = String(raw || '').trim().split(/\s+/)[0];
	return first && !first.startsWith('mdi-') ? first : fallback;
};
// Client dashboards / landing pages whose legacy `menu_section` is a v3 group
// ('Reporting'/'Admin') surface in that group's ToC after the static entries.
const v3ForSection = (section, icon, fallbackIcon) => {
	const g = v3Groups.find(x => x.text === section || x.key === String(section || '').toLowerCase());
	return g ? { parent: g.key, icon: v3SafeIcon(icon, fallbackIcon) } : undefined;
};

router.addDashboardRoutes = function(dashboards) {
	let dashboardRoutes = [];
	dashboards.forEach(d => {
		let name = d.name.replace(' ', '');
		name = name.charAt(0).toLowerCase() + name.slice(1);
		const path = "/u/:user/" + name;
		const newRoute = {
			name: name,
			path: path,
			component: d.dashboard_type === "INSIGHTS" ? Insights : dd,
			meta: { text: d.name, icon: d.icon, section: 'Reporting', newUi: true, oldUi: true, dashboardId: d.db_id, v3: v3ForSection('Reporting', d.icon, 'monitoring') }
		};
		storeDefaultMeta(newRoute);
		dashboardRoutes.push(newRoute);

		const currentRoute = router.getRoutes().find(c => c.name == newRoute.name);
		if (currentRoute)
			currentRoute.meta = newRoute.meta;
		else
			router.addRoute(newRoute);
	});

	return dashboardRoutes;
}

router.addLandingPages = function(landingPageConfigs) {
	router.getRoutes()
		.filter(r => r.meta && r.meta.landingPageId)
		.forEach(r => {
			r.meta = undefined;
		});

	landingPageConfigs.filter(p => p.menu_section !== 'Hidden').forEach((p, pi) => {
		let name = p.page_route;
		const path = "/u/:user/" + name;
		const menuSection = p.menu_section === 'Main' ? null : p.menu_section;
		const newRoute = {
			name: name,
			path: path,
			component: LandingFlex,
			meta: { text: p.title, section: menuSection, icon: p.icon, newUi: true, oldUi: false, landingPageId: p.lp_id, position: pi + 1, hideHeaderCreate: p.hide_header_create === 1, v3: v3ForSection(menuSection, p.icon, 'layers') }
		};
		storeDefaultMeta(newRoute);

		const currentRoute = router.getRoutes().find(c => c.name == newRoute.name);
		if (currentRoute) {
			currentRoute.meta = newRoute.meta;
			currentRoute.component = newRoute.component;
		} else {
			router.addRoute(newRoute);
		}
	});
}

// Per-customer meta overrides (route_meta_override table, edited in the Page
// Permissions → Meta Admin tab). Flat keys assign onto meta directly; dotted
// `v3.*` keys reconfigure the v3 nav (rail / parent / order / tocText /
// section / icon). v3 overrides rebase on the meta.Default snapshot so
// re-applying (login, customer switch) never stacks on a previous pass.
// `rail`/`order` coerce to numbers; the literal value 'none' REMOVES the
// property (e.g. v3.parent = none pulls a page out of its ToC), whereas
// deleting the override row restores the code default.
//
// Rows whose route_name is `v3group.<key>` are SYNTHETIC GROUP definitions
// (meta_key: text | icon | rail) — they restyle/re-position a code-declared
// group or, for an unknown key, add a per-customer group to the rail. Groups
// are rebuilt from v3GroupsDefault on every apply.
router.applyRouteMetaOverrides = function(overrides) {
	if (!overrides || !overrides.length) return;
	const routes = router.getRoutes();

	const groupRows = overrides.filter(o => String(o.route_name).startsWith('v3group.'));
	if (groupRows.length) {
		const byKey = {};
		(router.v3GroupsDefault || []).forEach(g => { byKey[g.key] = { ...g }; });
		groupRows.forEach(o => {
			const key = String(o.route_name).slice('v3group.'.length);
			if (!key) return;
			if (!byKey[key]) byKey[key] = { key, text: key, icon: 'folder', rail: 100 };
			if (o.meta_key === 'rail') {
				const n = Number(o.meta_value);
				if (!isNaN(n)) byKey[key].rail = n;
			} else if (o.meta_key === 'text' || o.meta_key === 'icon') {
				byKey[key][o.meta_key] = o.meta_value;
			}
		});
		router.v3Groups = Object.values(byKey);
	}

	const v3ByRoute = {};
	overrides.forEach(o => {
		if (String(o.route_name).startsWith('v3group.')) return;
		const route = routes.find(r => r.name === o.route_name);
		if (!route || !route.meta) return;
		if (String(o.meta_key).startsWith('v3.')) {
			if (!v3ByRoute[o.route_name]) {
				const base = (route.meta.Default ? route.meta.Default.v3 : route.meta.v3) || {};
				v3ByRoute[o.route_name] = { route, v3: { ...base } };
			}
			const prop = o.meta_key.slice(3);
			const v3 = v3ByRoute[o.route_name].v3;
			if (o.meta_value === null || o.meta_value === '' || o.meta_value === 'none') {
				delete v3[prop];
			} else if (prop === 'rail' || prop === 'order') {
				const n = Number(o.meta_value);
				if (!isNaN(n)) v3[prop] = n;
			} else {
				v3[prop] = o.meta_value;
			}
		} else {
			route.meta[o.meta_key] = o.meta_value;
		}
	});
	Object.values(v3ByRoute).forEach(({ route, v3 }) => {
		route.meta.v3 = Object.keys(v3).length ? v3 : undefined;
	});
}

// Full re-apply (used by the V3 Navigation editor after saving): restore every
// route's v3 config and the group list to their code defaults, then apply the
// given (post-save) override set — so deleted rows revert without a reload.
router.reapplyRouteMetaOverrides = function(overrides) {
	router.getRoutes().forEach(r => {
		if (r.meta && r.meta.Default) {
			r.meta.v3 = r.meta.Default.v3 ? { ...r.meta.Default.v3 } : undefined;
		}
	});
	router.v3Groups = (router.v3GroupsDefault || []).map(g => ({ ...g }));
	router.applyRouteMetaOverrides(overrides || []);
}

router.clearClientRoutes = function() {
	router.getRoutes()
		.filter(r => r.meta && (r.meta.dashboardId || r.meta.landingPageId))
		.forEach(r => {
			r.meta = undefined;
		});
}

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {
	if (to.name !== "default" && router.app.$loginState.defaultRoute && !router.app.$loginState.permittedRoutes.includes(to.name)) {
		// Prevent infinite redirect loop
		if (to.name === router.app.$loginState.defaultRoute) {
			next();
		} else {
			next({ name: router.app.$loginState.defaultRoute });
		}
	} else {
		next();
	}
});

let applicationName;

const setDocumentTitle = () => {
	const routeText = router.currentRoute?.meta?.text;
	const appName = applicationName || 'Role Mapper';
	document.title = routeText ? `${appName} - ${routeText}` : appName;
}

router.setAppName = (appName) => {
	applicationName = appName;
	setDocumentTitle();
}

router.afterEach(() => {
    Vue.nextTick(() => {
        setDocumentTitle();
    });
});

export default router
